import { render, staticRenderFns } from "./ItemBaseData.vue?vue&type=template&id=a4d19cc4"
import script from "./ItemBaseData.vue?vue&type=script&lang=js"
export * from "./ItemBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports